import { FileUploadTrend, FileStatsView } from '.';
import { FileTrackerError } from './FileTrackerError';
import {
  FileTrackerFileStats,
  FileUploadStatsDetails,
  FileTrackerMetrics,
  ChartDataProps,
} from '../file-tracker-types';
import { useEffect, useState } from 'react';
import { Spin, Card } from '@ssar-app/uikit';
import { Text } from '@chakra-ui/react';
interface fileTrackerMetricesProps {
  isMetricesRequired: {
    fileStats: boolean;
    fileUploadTrend: boolean;
  };
  getMetrics?: (monthValue: number) => Promise<FileTrackerMetrics | Error>;
}

export const FileTrackerMetrices = (props: fileTrackerMetricesProps) => {
  const { getMetrics, isMetricesRequired } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [fileStats, setFileStats] = useState<FileTrackerFileStats>({
    avgFileAvailableTime: 0,
    avgFileSize: 0,
    largeFiles: 0,
    totalFiles: 0,
  });
  const [fileStatusData, setFileStatusData] = useState<FileUploadStatsDetails>({
    available: 0,
    sampling: 0,
    malwareScan: 0,
    received: 0,
  });
  const [percentageData, setPercentageData] = useState<FileUploadStatsDetails>({
    available: 0,
    sampling: 0,
    malwareScan: 0,
    received: 0,
  });
  const [chartData, setChartData] = useState<ChartDataProps>([]);
  const [selectedOption, setSelectedOption] = useState(1);
  const [error, setError] = useState<Error | null>(null);
  const SelectOptions: {
    value: number;
    label: string;
  }[] = [
    { value: 1, label: 'This Month' },
    { value: 3, label: 'Last 3 Months' },
    { value: 6, label: 'Last 6 Months' },
    { value: 12, label: 'Last 12 Months' },
  ];

  const fetchMetrices = async () => {
    if (getMetrics) {
      setIsLoading(true);
      const metrics = await getMetrics(selectedOption);
      if (metrics instanceof Error) {
        setError(metrics);
      } else {
        setFileStats(metrics.stats);
        setFileStatusData(metrics.fileUploadStats.details);
        setPercentageData(metrics?.fileUploadStats.percentagedetails);
        setChartData(metrics.fileUploadStats.chartData);
      }
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchMetrices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <Spin
      spinning={isLoading}
      containerProps={{
        zIndex: 'inherit',
        position: 'relative',
      }}
      spinWrapperProps={{ zIndex: 1 }}
      tip='Loading Metrics'
    >
      {!error ? (
        <>
          {isMetricesRequired.fileStats && (
            <FileStatsView fileData={fileStats} />
          )}
          {isMetricesRequired.fileUploadTrend && (
            <FileUploadTrend
              chartData={chartData}
              fileStatsData={fileStatusData}
              setSelectedOption={setSelectedOption}
              selectedOption={selectedOption}
              SelectOptions={SelectOptions}
              percentageData={percentageData}
            />
          )}
        </>
      ) : (
        <Card mt={3} w='full'>
          <Text fontSize='md' fontWeight='semibold' textTransform='uppercase'>
            Metrics
          </Text>
          <FileTrackerError
            reloadFn={() => {
              setError(null);
              fetchMetrices();
            }}
            errorMsg='We encountered an unexpected error while getting the file tracker metrics. Please try again.'
          />
        </Card>
      )}
    </Spin>
  );
};
